module.exports = __webpack_public_path__ + "img/yishi6.54031994.jpg";